import { render, staticRenderFns } from "./RTaskFields.vue?vue&type=template&id=ac59b14e&scoped=true&"
import script from "./RTaskFields.vue?vue&type=script&lang=js&"
export * from "./RTaskFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac59b14e",
  null
  
)

export default component.exports